// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1YRk1","title":"AfterBackImages_title__2NQpj","images":"AfterBackImages_images__2XivX"};